import { getPageAssetUrl } from '../../template.js';

/**
 * Get the default background for the page.
 * @param {object} page Parabo original page data
 * @param {object} template Parabo template data
 * @param {boolean} useServerAssets
 * @returns {object}
 */
const getDefaultBackground = (page, template, useServerAssets) => {
  const suffix = useServerAssets && page.layer != null ? `-${page.layer}` : '';
  return getPageAssetUrl(template, page.id, { useServerAssets, suffix });
};

export default getDefaultBackground;
